import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { SkodaLink } from '../../buttons';
import { CircularProgress } from '../../circularProgress';
import { useDynamicPercentage, useExpiryDateText, useRemainingValueText } from '../hooks';
import { WarrantyBaseProps } from '../types';

const useStyles = makeStyles({ name: 'WarrantySmall-1' })(theme => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		maxWidth: 400
	},
	title: {
		fontWeight: 700,
		fontSize: '18px',
		lineHeight: '28px',
		letterSpacing: '0.02em',
		marginBottom: 13,
		textAlign: 'center'
	},
	valuesPanel: {
		display: 'flex',
		gap: 35
	},
	remainingPanel: {
		display: 'flex',
		flexDirection: 'column',
		fontSize: '16px',
		lineHeight: '24px',
		letterSpacing: '0.02em'
	},
	labelRemaining: {
		color: '#9E9FA0',
		fontWeight: 700
	},
	valueRemaining: {
		fontWeight: 700
	},
	expiryDate: {
		fontSize: '12px',
		lineHeight: '16px',
		letterSpacing: '0.02em',
		whiteSpace: 'nowrap',
		marginBottom: 12
	},
	linkConditions: {
		fontWeight: 700,
		fontSize: '12px',
		lineHeight: '12px',
		cursor: 'pointer',
		marginTop: 24
	},
	circularProgressLabel: {
		fontSize: '16px',
		lineHeight: '26px'
	}
}));

export const WarrantySmall1 = (props: WarrantyBaseProps) => {
	const { translations, value, max, className, link } = props;
	const { classes, cx } = useStyles(null, { props });

	const dynamicValue = useDynamicPercentage(value, max);
	const remainingValueText = useRemainingValueText(props);
	const expiryDateText = useExpiryDateText(props);

	return (
		<div className={cx(classes.root, className)}>
			{translations.title && <span className={classes.title}>{translations.title}</span>}
			<div className={classes.valuesPanel}>
				<CircularProgress classes={{ circularProgressLabel: classes.circularProgressLabel }} value={dynamicValue} variant='determinate' size={93} thickness={10} />
				<div className={classes.remainingPanel}>
					<span className={classes.labelRemaining}>{translations.remainingLabel}</span>
					<span className={classes.valueRemaining}>{remainingValueText}</span>
					{expiryDateText && <span className={classes.expiryDate}>{expiryDateText}</span>}
					{link && <SkodaLink hideIcon href={link} target='_blank' className={classes.linkConditions}>{translations.linkConditions}</SkodaLink>}
				</div>
			</div>
		</div>
	);
};
